import React from 'react';
import AccordionDetails from '@mui/material/AccordionDetails';
import Item from './Item';

const accordionDetailsStyles = {
  backgroundColor: 'surface.white',
  px: 3,
  py: 0,
};

const EmptyLoad = () => {
  return (
    <AccordionDetails sx={accordionDetailsStyles}>
      <Item label="Load Type" value="--" />
    </AccordionDetails>
  );
};

export default EmptyLoad;
